import { useEffect, useRef } from "react";
import { ORDER_POLL_MS } from "../constants";

/** Ponawia przejściowe błędy z ograniczonym opóźnieniem i bez nakładających się odczytów. */
export default function useOrderPolling(enabled, poll, onError) {
  const handlers = useRef({ poll, onError });
  handlers.current = { poll, onError };
  useEffect(() => {
    if (!enabled) return;
    let active = true;
    let failures = 0;
    let timer;
    const controller = new AbortController();
    const tick = async () => {
      try {
        await handlers.current.poll(controller.signal);
        failures = 0;
      } catch (error) {
        if (active) {
          failures++;
          handlers.current.onError(error);
        }
      } finally {
        if (active)
          timer = setTimeout(
            tick,
            Math.min(ORDER_POLL_MS * 2 ** failures, 30000),
          );
      }
    };
    timer = setTimeout(tick, ORDER_POLL_MS);
    return () => {
      active = false;
      controller.abort();
      clearTimeout(timer);
    };
  }, [enabled]);
}
